import { Link, Navigate } from 'react-router-dom';
import { Callout } from '../components/Callout';
import { Card } from '../components/Card';
import { Eyebrow } from '../components/Eyebrow';
import { CargaPagina } from '../components/Spinner';
import { useMisEventos } from './useMisEventos';

const ETIQUETA_ROL = { asesor: 'Asesor', staff: 'Staff' } as const;

/** /panel: si solo hay un evento vinculado, entra directo; si hay varios, elige. */
export function PanelInicioScreen() {
  const { eventos, error } = useMisEventos();

  if (error) {
    return (
      <div className="p-4 sm:p-6">
        <Callout tono="error">{error}</Callout>
      </div>
    );
  }
  if (!eventos) return <CargaPagina />;
  if (eventos.length === 1) return <Navigate to={`/panel/${eventos[0]!.eventoId}`} replace />;

  return (
    <div className="mx-auto max-w-xl space-y-4 p-4 sm:p-6">
      <Eyebrow>Mi panel</Eyebrow>
      <h1 className="text-xl font-semibold text-texto">Elige un evento</h1>

      {eventos.length === 0 ? (
        <Callout tono="alerta">
          Todavía no estás vinculado a ningún evento. Pide a un administrador que te agregue.
        </Callout>
      ) : (
        <ul className="space-y-2">
          {eventos.map((e) => (
            <li key={e.eventoId}>
              <Link to={`/panel/${e.eventoId}`}>
                <Card className="flex items-center justify-between gap-3 p-4 transition hover:border-navy/30">
                  <span className="font-medium text-texto">{e.nombre}</span>
                  <span className="flex shrink-0 gap-1.5">
                    {e.roles.map((r) => (
                      <span
                        key={r}
                        className="rounded-full bg-navy/5 px-2.5 py-0.5 text-xs font-medium text-navy"
                      >
                        {ETIQUETA_ROL[r]}
                      </span>
                    ))}
                  </span>
                </Card>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
